var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-toolbar', {
    staticClass: "elevation-1 rounded mt-2 white"
  }, [_c('div', {
    staticClass: "d-flex",
    staticStyle: {
      "gap": "30px"
    }
  }, [_vm.hasTora ? _c('div', {
    staticClass: "d-flex align-center"
  }, [_c('span', {
    staticClass: "font-weight-bold secondary--text"
  }, [_c('img', {
    staticClass: "mr-1",
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "width": "25px",
      "src": "https://assets.trainplanet.com/wlabel/trainplanet/logos/favicon-32x32.png",
      "alt": "tora-logo"
    }
  }), _vm._v("Tora : ")]), _c('div', {
    staticClass: "d-flex align-center ml-2"
  }, _vm._l(_vm.groupedToraBooking.groupedExternalIds, function (id, index) {
    return _c('span', {
      key: id,
      staticClass: "font-weight-black secondary--text"
    }, [_vm._v(" " + _vm._s(id) + " "), _c('v-tooltip', {
      attrs: {
        "top": "",
        "open-delay": 1000,
        "close-delay": 500,
        "open-on-hover": false
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function (_ref) {
          var on = _ref.on;
          return [_c('v-icon', _vm._g({
            attrs: {
              "color": "mango-red",
              "small": ""
            },
            on: {
              "click": function ($event) {
                return _vm.copyToClipboard(id);
              }
            }
          }, on), [_vm._v("mdi-content-copy")])];
        }
      }], null, true)
    }, [_c('span', [_vm._v("Copied")])]), index !== _vm.groupedToraBooking.groupedExternalIds.length - 1 ? _c('span', {
      staticClass: "black--text mx-1"
    }) : _vm._e()], 1);
  }), 0)]) : _vm._e(), _vm.hasLinkonline ? _c('div', {
    staticClass: "d-flex align-center"
  }, [_c('span', {
    staticClass: "font-weight-bold secondary--text"
  }, [_c('img', {
    staticClass: "mr-1",
    attrs: {
      "width": "20px",
      "src": require("@/assets/linkonline.svg"),
      "alt": "linkonline-logo"
    }
  }), _vm._v("Linkonline : ")]), _c('div', {
    staticClass: "d-flex align-center ml-2"
  }, _vm._l(_vm.groupedLinkonlineBooking.groupedExternalIds, function (id, index) {
    return _c('span', {
      key: id,
      staticClass: "font-weight-black secondary--text"
    }, [_vm._v(" " + _vm._s(id) + " "), _c('v-tooltip', {
      attrs: {
        "top": "",
        "open-delay": 1000,
        "close-delay": 500,
        "open-on-hover": false
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function (_ref2) {
          var on = _ref2.on;
          return [_c('v-icon', _vm._g({
            attrs: {
              "color": "mango-red",
              "small": ""
            },
            on: {
              "click": function ($event) {
                return _vm.copyToClipboard(id);
              }
            }
          }, on), [_vm._v("mdi-content-copy")])];
        }
      }], null, true)
    }, [_c('span', [_vm._v("Copied")])]), index !== _vm.groupedLinkonlineBooking.groupedExternalIds.length - 1 ? _c('span', {
      staticClass: "black--text mx-1"
    }) : _vm._e()], 1);
  }), 0)]) : _vm._e(), _vm.bookings.length < 1 ? _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(" No External Booking")]) : _vm._e()]), _c('v-spacer'), _c('v-toolbar-title', {
    staticClass: "font-weight-bold black--text d-flex align-center"
  }, [_c('img', {
    staticClass: "mr-2",
    attrs: {
      "width": "26px",
      "src": _vm.tenantLogoUrl,
      "alt": "tenant-logo"
    }
  }), _vm._v(" " + _vm._s(_vm.tenantName) + " ")])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }